import React from 'react';
import PropTypes from 'prop-types';
import { useT, useBundle } from '~app/BundleProvider';

const IntroText = ({ page, style, articleRef }) => {
  const t = useT();
  const { language } = useBundle();
  let textStyle = "intro-text__container";
  if (language === "es") {
    textStyle = "intro-text__container-small";
  }
  return (
    <article className={textStyle} ref={articleRef} tabIndex="-1">
      <div className="intro-text" style={style}>
        {t(`${page}-description`)}
      </div>
    </article>
  );
};

IntroText.propTypes = {
  page: PropTypes.string.isRequired,
  styles: PropTypes.object,
  articleRef: PropTypes.func,
};

IntroText.defaultProps = {
  style: {},
};

export default IntroText;



// WEBPACK FOOTER //
// ./src/pages/intro/IntroText.js